import { siteConfig } from '@/constants/site'

const base = siteConfig.url.replace(/\/+$/, '')

export const absoluteUrl = (path = '/'): string => {
    if (!path || path === '/') return `${base}/`

    /* CMS image fields store an absolute CDN URL. Leave those alone, or the
       canonical host gets prefixed onto a URL that is already complete. */
    if (/^https?:\/\//i.test(path)) return path

    return `${base}${path.startsWith('/') ? path : `/${path}`}`
}
